/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimImportantDates
 */
export interface ClaimImportantDates {
    /**
     * 
     * @type {string}
     * @memberof ClaimImportantDates
     */
    claimNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimImportantDates
     */
    dateOfLoss: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimImportantDates
     */
    dateOfInstruction: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimImportantDates
     */
    firstReportDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimImportantDates
     */
    claimCreatedDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimImportantDates
     */
    lastModifiedDate: Date;
}

/**
 * Check if a given object implements the ClaimImportantDates interface.
 */
export function instanceOfClaimImportantDates(value: object): value is ClaimImportantDates {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('dateOfLoss' in value) || value['dateOfLoss'] === undefined) return false;
    if (!('dateOfInstruction' in value) || value['dateOfInstruction'] === undefined) return false;
    if (!('firstReportDate' in value) || value['firstReportDate'] === undefined) return false;
    if (!('claimCreatedDate' in value) || value['claimCreatedDate'] === undefined) return false;
    if (!('lastModifiedDate' in value) || value['lastModifiedDate'] === undefined) return false;
    return true;
}

export function ClaimImportantDatesFromJSON(json: any): ClaimImportantDates {
    return ClaimImportantDatesFromJSONTyped(json, false);
}

export function ClaimImportantDatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimImportantDates {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'dateOfLoss': (new Date(json['dateOfLoss'])),
        'dateOfInstruction': (new Date(json['dateOfInstruction'])),
        'firstReportDate': (new Date(json['firstReportDate'])),
        'claimCreatedDate': (new Date(json['claimCreatedDate'])),
        'lastModifiedDate': (new Date(json['lastModifiedDate'])),
    };
}

export function ClaimImportantDatesToJSON(value?: ClaimImportantDates | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'dateOfLoss': ((value['dateOfLoss']).toISOString().substring(0,10)),
        'dateOfInstruction': ((value['dateOfInstruction']).toISOString().substring(0,10)),
        'firstReportDate': ((value['firstReportDate']).toISOString().substring(0,10)),
        'claimCreatedDate': ((value['claimCreatedDate']).toISOString().substring(0,10)),
        'lastModifiedDate': ((value['lastModifiedDate']).toISOString().substring(0,10)),
    };
}

